import { safeProductId } from '@/src/lib/seo';
import { generateSlug, safeName, slugify } from '@/src/lib/utils/slugify';

class RouterConfig {
  stores = '/stores';
  branchDetails = (id: string | number, storeName: string) => `/stores/${slugify(id, storeName)}`;

  productDetails = (
    branchId: string,
    storeName: string,
    integrationId: string | number,
    productName: string,
  ) =>
    `/stores/${slugify(branchId, storeName)}/product/${generateSlug(integrationId, productName)}`;
  customListOfBranches = '/cms-list-of-branches';
  accessDenied = 'access-denied';
  joinUs = '/join-us';
  account = '/account';
  wishlist = this.account + '/wishlist';
  profile = this.account + '/profile';
  wallet = this.account + '/wallet';
  payment = this.account + '/payment';
  prime = this.account + '/prime';
  contactUs = '/contact-us';
  aboutUs = '/about-us';
  privacyPolicy = '/privacy-policy';
  termsAndCondition = '/terms-condition';
  addresses = this.account + '/addresses';
  reportedIssues = this.account + '/reported-issues';
  reportedIssueDetails = (id: string | number) => this.reportedIssues + `/${id}`;
  createAddress = this.addresses + '/create';
  editAddress = (id: string) => this.addresses + `/edit/${id}`;
  order = this.account + '/orders';
  orderDetails = (id: number) => `/order/${id}`;

  paymentSuccessOrder = (id: number | string) => `/order/${id}/PaymentSuccess`;
  cards = '/cards';
  checkout = (id: string | number) => `/checkout/${id}`;
  carts = '/carts';
  digitalCards = '/digital-cards';
  digitalCardDetails = (id: string) => `/digital-cards/${safeProductId(id)}`;
  search = '/search';
  mainCheckout = '/checkout';
  explorPage = (explorName: string, id: string) => `${safeName(explorName)}/${id}`;
}

class ApiRouter {
  profile = 'mobile/v2/profiles';
  profileEdit = 'mobile/profile';
  payment = 'mobile/payments/cards';
  searchProducts = 'catalog/menu/search';
  prime = 'mobile/prime/has-active-subscription';
  cities = 'portal/cities/active-cities';

  // store
  stores = 'core/branches/nearby';
  branchesEta = 'core/branches/nearby-eta';
  storesIndustries = 'stores/grouped-industries';
  closestBranch = (id: string) => `mobile/branches/nearest-store-branch/${id}`;
  branch = (id: string) => `mobile/branches/${id}`;
  allProductsForBranch = (id: string) => `catalog/menu/branches/${id}/products`;
  filteredProducts = (branchId: string) => `catalog/menu/branches/${branchId}/products/filter`;
  allProductsForBranchWithCategory = (branchId: string, categoryId: string) =>
    `mobile/branches/${branchId}/industries/${categoryId}/products`;
  storeDepatments = 'core/departments';
  industries = 'catalog/industries';
  storeCategories = (branchId: string) => `mobile/stores/branches/${branchId}/navigation-sections`;
  storeCoupons = (branchId: string) => `mobile/stores/${branchId}/coupons`;
  storeCms = (storeId: string, branchId: string) => `cms/v2/explore/${storeId}/store/${branchId}`;
  subNavigationSections = `mobile/stores/navigation-sections/sub-navigation-sections`;

  // start cart

  allCarts = 'mobile/carts';
  addProductToCart = `mobile/carts`;
  updateProductCart = 'mobile/carts';
  cartById = (id: string) => `mobile/carts/${id}`;
  deleteCart = (id: number | string) => `mobile/carts/${id}`;
  removeProductFromCart = (cartId: number | string, itemId: string) =>
    `mobile/carts/${cartId}/items/${itemId}`;

  // chechout
  checkout = (id: string) => `mobile/carts/${id}/checkout-validation`;
  createOrder = 'mobile/orders/create';
  payOrder = (id: string) => `mobile/orders/${id}/pay`;

  // payment
  removePayment = (id: string) => `mobile/payments/cards/${id}`;
  getAllowdPayments = 'mobile/payments/configurations';
  changeOrderPaymentMethod = (orderId: string) => `mobile/orders/${orderId}/payment-method`;

  // wallet
  getWallet = 'users/wallets';
  getWalletBalance = `mobile/wallet/balance`;

  //getOrders count
  getOrdersCount = 'mobile/orders/count';

  // cms
  cmsSections = 'cms/v2/explore';
  cmsSectionsV2 = 'cms/v2/explore/v2';
  getContactUs = 'cms/contact-us';
  getGenericContent = 'cms/generic-content';
  getUsersWallets = 'users/wallets';
  getAllProductsById = 'cms/v2/explore/all-products';
  getExplrePage = (id: string) => `cms/v2/explore/page/${id}`;
  getExplrePageV2 = (id: string) => `cms/v2/explore/v2/page/${id}`;
  getLiveStoreTime = `mobile/stores/storesMinimalInfo`;

  // cms destinations v2
  destinationStore = 'cms/v2/destinations/store';
  destinationStores = 'cms/v2/destinations/stores';
  destinationProducts = 'cms/v2/destinations/products';
  destinationProduct = 'cms/v2/destinations/product';

  // countryLocation
  getCountryIdFromLocation = 'mobile/countries/locate';

  // wishlist
  getWishlists = 'mobile/wishlists';
  createWishlist = 'users/wishlists/items/add-or-delete';
  getMyAllWishlist = 'mobile/wishlists/items/minimal';

  // order history

  orderHistory = 'mobile/customer-orders';
  orderDetails = (id: string | number) => `mobile/orders/${id}/details`;

  // issue request
  issueConfig = `mobile/Issues/configs`;
  submitIssue = `mobile/Issues/submit`;
  uploadIssueImage = (issueId: string) => `mobile/issues/${issueId}/upload`;
  listedIssues = `mobile/issues`;
  issueDetails = (id: string) => `mobile/issues/${id}/details`;
  cancelIssue = (id: string) => `mobile/issues/${id}/cancel`;

  //addresses
  allAddresses = 'users/addresses';
  addAddress = 'users/addresses';
  deleteAddress = (id: string | number) => `users/addresses/${id}`;
  updateAddress = (id: string | number) => `users/addresses/${id}`;
  addressById = (id: string | number) => `users/addresses/${id}`;

  // copone
  allCopone = 'mobile/my-coupons';

  // cancel Order
  cancelOrder = (id: number) => `mobile/orders/${id}/cancel-with-reason`;

  // reorder Order
  reorder = `orders/reorder`;

  // digital cards
  digitalCards = 'mobile/digital-cardsv2/products';
  digitalCardDetails = (id: string | number) => `mobile/digital-cards/products/${id}`;
  digitalCardCategories = 'mobile/digital-cards/products/categories';
  // join us
  getAllActiveCountries = 'mobile/countries/active';
  getCitiesByCountry = `mobile/cities`;

  getAllCities = 'mobile/cities';

  // gift
  getGift = (token: string) => `mobile/orders/gift/${token}`;

  // POST Gift
  giftInfo = (token: string) => `mobile/orders/gift/${token}`;
}

export const Routes = new RouterConfig();

export const ApiRouts = new ApiRouter();
